<div class="pull-right removeForPrint">
  <div class="form-inline">
    <div class="input-group" style="width:186px">
      <span class="input-group-addon">from</span>
      <input type="text" class="form-control"
             [maxDate]="maxDateValue"
             (bsValueChange)="dateChangeEmitter.emit($event)"
             #datePicker="bsDatepicker" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }"
             bsDatepicker [bsValue]="fromDate">
      <span class="input-group-btn">
          <button type="button" class="btn btn-default" (click)="datePicker.toggle()" [attr.aria-expanded]="datePicker.isOpen">
            <i class="glyphicon glyphicon-calendar"></i></button>
      </span>
    </div>
    <button style="font-size: smaller; width: 110px; margin-left: 10px;" class="btn btn-primary"
            [disabled]="disabled"
            (click)="dateChangeEmitter.emit(fromDate)">
      Refresh
    </button>
  </div>
</div>